import styledIn, { CreateStyled } from "@emotion/styled";

import { theme as chakraTheme } from "@chakra-ui/core";
import icons from "./icons";

export type ChartTheme = {
  color: string;
  text: {
    color: string;
    size: number;
  };
  tick: string;
};

const chakraExtend = {
  ...chakraTheme,
  icons: {
    ...icons,
    ...chakraTheme.icons
  },
  fonts: {
    ...chakraTheme.fonts,
    heading:
      "-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Ubuntu,sans-serif;"
  }
};

export const theme = {
  ...chakraExtend,
  color: {
    brand: "#38ca80"
  }
};

//console.log(theme);
export type Theme = typeof theme;
export const styled = styledIn as CreateStyled<Theme>;
